import React from 'react';

import useStyles from './styles';
import { Skeleton } from '@material-ui/lab';
import { Box } from '@material-ui/core';
function CPP_AmenitiesAndFacilitiesSkeleton() {
  const styles = useStyles();

  const Divider = () => <Skeleton variant='rect' height={1} width={'100%'} />;

  return (
    <Box className={styles.CPP_AmenitiesAndFacilitiesSkeletonWrapper}>
      <Box className={styles.fieldWrapper}>
        <Skeleton variant='rect' height={20} width={220} />
        <Skeleton variant='rect' height={44} width={512} />
      </Box>
      <Divider />
      <Box className={styles.fieldWrapper}>
        <Skeleton variant='rect' height={20} width={220} />
        <Skeleton variant='rect' height={44} width={512} />
      </Box>
    </Box>
  );
}

export default CPP_AmenitiesAndFacilitiesSkeleton;
